import React from 'react';

const DIV = ({ children, ...props }) => {
  //! State

  //! Function

  //! Render
  return <div {...props}>{children}</div>;
};

export default DIV;
